import React from 'react'
import './Service.css'

function Service() {
    return (
        <div>
            <div className="profile-container service">
                <span>Services</span>
                <div className="servive-container">
                    <h2>We Create meaningful digital solutions <br /> that level up your business</h2>

                    <div className='cc1'>
                        <div className='dblock'>
                            <p>

                                Elevating businesses with expertly designed and executed digital <br /> strategies. Crator is here to help you conquer the online space <br /> one pexel at a time.
                            </p>

                            <p>

                                Elevating businesses with expertly designed and executed digital <br /> strategies. Crator is here to help you conquer the online space <br /> one pexel at a time.
                            </p>

                            <p>

                                Elevating businesses with expertly designed and executed digital <br /> strategies. Crator is here to help you conquer the online space <br /> one pexel at a time.
                            </p>
                        </div>
                        {/* <button className='btn' s get started></button> */}
                        <div className="service-container-img">
                            <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fhero-services-01.db440b3f.jpg&w=360&q=75" alt="" />
                            <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fhero-services-02.fdc9b7bf.jpg&w=360&q=75" alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="profile-container">
                <div className="product-development">
                    <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ffeatures-alternating-simple-01.34c3fba0.jpg&w=640&q=75" alt="" />

                    <div>
                        <span>Product development</span>
                        <h2>Innovative digital <br /> solutions</h2>
                        <p>
                            We specialize in crafting top-tier digital products that are <br /> perfectly tailored to your brand's needs. From ideation to <br /> execution, we turn ideas into tangible realities.
                        </p>
                    </div>
                </div>
            </div>


            <div className="profile-container">
                <div className="design">
                    <div>
                        <span>Design</span>
                        <h2>Designing for better <br /> user experiences</h2>
                        <p>
                            Our approach leverages the power of aesthetics to  <br />create unparalleled user experiences. By balancing <br />beauty and functionality, we make the complex simple, <br /> and the ordinary extraordinary.
                        </p>
                    </div>
                    <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ffeatures-alternating-simple-02.0ae6392f.jpg&w=640&q=75" alt="" />
                </div>
            </div>


            <div className="profile-container">
                <div className="product-development">
                    <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ffeatures-alternating-simple-03.c8a70d8c.jpg&w=640&q=75" alt="" />

                    <div>
                        <span>Optimization</span>
                        <h2>State of the art <br /> performance</h2>
                        <p>
                            We're committed to maximizing efficiency and <br />performance through the use of cutting-edge <br />technologies. We strive to ensure that each solution we <br /> provide is optimized for success.
                        </p>
                    </div>
                </div>
            </div>

            <div className="profile-container">
                <div className="offer">
                    <div className='offs'>
                        <span>What we offer</span>
                        <h1>We've Got You <br /> Covered</h1>
                    </div>
                    <div>
                        <div>
                            <div className='icon-box'>
                                <i class="fab fa-pied-piper-square"></i>
                            </div>
                            <h2>UI/UX Design</h2>
                            <p>
                                Transforming ideas into visually compelling <br /> and functional designs that users love.
                            </p>
                        </div>

                        <div>
                            <div className='icon-box'>
                                <i class="fab fa-pied-piper-square"></i>
                            </div>
                            <h2>Mobile App Development</h2>
                            <p>
                                Creating intuitive, feature-rich mobile apps <br /> that engage and retain users.
                            </p>
                        </div>

                        <div>
                            <div className='icon-box'>
                                <i class="fab fa-pied-piper-square"></i>
                            </div>
                            <h2>Branding Services</h2>
                            <p>
                                Building strong, cohesive brand identities <br /> that resonate with target audiences.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div className='icon-box'>
                                <i class="fab fa-pied-piper-square"></i>
                            </div>
                            <h2>Web Development</h2>
                            <p>
                                Crafting robust and responsive websites that <br /> seamlessly operate across devices.
                            </p>
                        </div>

                        <div>
                            <div className='icon-box'>
                                <i class="fab fa-pied-piper-square"></i>
                            </div>
                            <h2>Digital Marketing</h2>
                            <p>
                                Driving brand awareness and growth <br /> through tailored digital marketing strategies.
                            </p>
                        </div>

                        <div>
                            <div className='icon-box'>
                                <i class="fab fa-pied-piper-square"></i>
                            </div>
                            <h2>SEO Optimization</h2>
                            <p>
                                Enhancing your online visibility and ranking <br /> through proven SEO strategies.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="profile-container">
                <div className="design">
                    <div>
                    <span>Strategic Approach</span>
                        <h2>
                            Let’s Drive Your Brand <br /> Forward
                        </h2>

                        <p>
                            With a fusion of data-driven tactics and creative storytelling, we <br /> elevate your brand. Our team empowers your business, pushing <br /> it beyond the ordinary to achieve unparalleled success.
                        </p>

                        <small>
                            <i class="fas fa-check-double"></i>
                            <p>In-depth market research and analysis.</p>
                        </small>

                        <small>
                            <i class="fas fa-check-double"></i>
                            <p>Comprehensive brand strategy formulation.</p>
                        </small>

                        <small>
                            <i class="fas fa-check-double"></i>
                            <p>Focused brand message and value proposition.</p>
                        </small>
                    </div>
                    <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ffeatures-alternating-simple-02.0ae6392f.jpg&w=640&q=75" alt="" />
                </div>
            </div>


            <div className="profile-container">
                <div className="our-process ">
                    <div className="our-process-div yx">
                        <span><b>Our Partners:</b></span>
                        <h1>Experience our simple design <br /> process</h1>
                        <p>
                            Uncover the essence of your brand, through our highly collaborative and <br /> intuitively structured design process.
                        </p>

                        <div className="card-data">
                            <div className="data">
                                <div>
                                    <i class="fas fa-scroll"></i>
                                </div>
                                <h2>1.Collect Ideas</h2>
                                <p>
                                    We gather comprehensive insights about <br /> your product to fully understand your <br /> unique needs and vision.
                                </p>
                            </div>

                            <div className="data">
                                <div>
                                    <i class="fab fa-slack-hash"></i>
                                </div>
                                <h2>2. Design Concept</h2>
                                <p>
                                    We creatively dHctdHJhbnNmb3Jt your <br /> vision and ideas into design drafts. We <br />iterate until you are satisfied.
                                </p>
                            </div>

                            <div className="data">
                                <div>
                                    <i class="fas fa-rocket"></i>
                                </div>
                                <h2>3. Finalize Product</h2>
                                <p>
                                    Upon your approval, we finalize and refine <br /> the design and launch your uniquely <br />tailored product to the market.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="profile-container">
                <div className="promo">
                    <h1>
                        Let's make something <br /> great together.
                    </h1>
                    <button className='btn-service'>Let's connect</button>
                </div>
            </div>
        </div>
    )
}

export default Service